module.exports = __webpack_public_path__ + "img/777D7D_BDCAD2_3E3C2E_B1B8B6-256px.669f4b75.png";